(function () {
    function initBannerSlider(section) {
        const track = section.querySelector('.banner-slider-track');
        if (!track) return;

        const prevBtn = section.querySelector('.banner-slider-nav.prev');
        const nextBtn = section.querySelector('.banner-slider-nav.next');
        const dots = section.querySelectorAll('.banner-slider-dot');
        const slides = section.querySelectorAll('.banner-slide-item');

        if (!slides.length) return;

        function updateActiveDot() {
            if (!dots.length) return;
            const scrollLeft = track.scrollLeft;
            const slideWidth = slides[0].offsetWidth + 16;
            const currentIndex = Math.round(scrollLeft / slideWidth);
            dots.forEach((dot, i) => {
                if (i === currentIndex) {
                    dot.classList.add('active');
                } else {
                    dot.classList.remove('active');
                }
            });
        }

        track.addEventListener('scroll', updateActiveDot, { passive: true });

        if (prevBtn && nextBtn) {
            prevBtn.addEventListener('click', () => {
                const slideWidth = slides[0].offsetWidth + 16;
                track.scrollBy({ left: -slideWidth, behavior: 'smooth' });
            });

            nextBtn.addEventListener('click', () => {
                const slideWidth = slides[0].offsetWidth + 16;
                track.scrollBy({ left: slideWidth, behavior: 'smooth' });
            });
        }

        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                const slideWidth = slides[0].offsetWidth + 16;
                track.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
            });
        });

        let isDown = false;
        let startX;
        let scrollLeft;

        track.addEventListener('mousedown', (e) => {
            isDown = true;
            startX = e.pageX - track.offsetLeft;
            scrollLeft = track.scrollLeft;
        });

        track.addEventListener('mouseleave', () => {
            isDown = false;
        });

        track.addEventListener('mouseup', () => {
            isDown = false;
        });

        track.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - track.offsetLeft;
            const walk = (x - startX) * 1.5;
            track.scrollLeft = scrollLeft - walk;
        });
    }

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.banner-carousel-section').forEach(initBannerSlider);
    });

    if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', (e) => {
            if (
                e.target.classList.contains('banner-carousel-section') ||
                e.target.querySelector('.banner-carousel-section')
            ) {
                initBannerSlider(e.target.querySelector('.banner-carousel-section') || e.target);
            }
        });
    }
})();